import React from "react";
import {Step} from "../api/model/scenario";
import {Quotation} from "../model/quotation";

interface Props {
    currentStep: Step;
    setCurrentStep: React.Dispatch<React.SetStateAction<Step>>;
    previousStep: Step;
    setPreviousStep: React.Dispatch<React.SetStateAction<Step>>;
    nextStageHandler: (quotation: Quotation) => void;
    backStageHandler: (quotation: Quotation) => void;
    pushPreviousQuotationStepCode: (code: string) => void;
    popPreviousQuotationStepCode: () => string;
    stepMessages: Array<string>;
    setStepMessages: (value: Array<string>) => void;
}

export const ScenarioContext = React.createContext<Props>({
    currentStep: null,
    setCurrentStep: () => {},
    previousStep: null,
    setPreviousStep: () => {},
    nextStageHandler: () => {},
    backStageHandler: () => {},
    pushPreviousQuotationStepCode: (code: string) => {},
    popPreviousQuotationStepCode: () => '',
    stepMessages: null,
    setStepMessages: () => {}
});